import CloseIcon from '@mui/icons-material/Close';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { BaseModal } from '@src/common/components/BaseModal';
import { Button } from '@src/common/components/button/Button';
import { Divider } from '@src/common/components/Divider';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import { useNavigateToOrderDetails } from '@src/orders/hooks/useNavigateToOrderDetails';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  orderId: string;
  formIsDirty: boolean;
  onSave: () => void;
}

export const CloseEditOrderButton = ({
  orderId,
  formIsDirty,
  onSave,
}: Props) => {
  const { t } = useTranslation();
  const { navigateToOrderDetails } = useNavigateToOrderDetails();
  const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState(false);

  const goToOrderDetails = () => void navigateToOrderDetails({ orderId });

  const closeForm = () => {
    if (formIsDirty) {
      setShowUnsavedChangesModal(true);
    } else {
      goToOrderDetails();
    }
  };

  return (
    <>
      <Button
        type="button"
        onClick={closeForm}
        variant="text"
        startIcon={<CloseIcon />}
      >
        {t('close')}
      </Button>

      <BaseModal
        title={t('unsavedChangesModal.title')}
        subtitle={t('unsavedChangesModal.description')}
        onClose={() => setShowUnsavedChangesModal(false)}
        open={showUnsavedChangesModal}
      >
        <Divider style={{ marginBottom: theme.spacing['8'] }} />
        <Stack direction="row" gap={theme.spacing['2']} justifyContent="end">
          <Button type="button" variant="outlined" onClick={goToOrderDetails}>
            {t('discardChanges')}
          </Button>
          <Button
            type="button"
            onClick={onSave}
            variant="contained"
            startIcon={<SaveOutlinedIcon />}
          >
            {t('saveChanges')}
          </Button>
        </Stack>
      </BaseModal>
    </>
  );
};
